import { number, object } from "yup";

import { draftValidationSchema, titleValidationSchema } from "@dzambalaorg/yup-rules";
import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";

export const achievementLevelsValidationSchema = object().shape({
  title: titleValidationSchema,
  description: draftValidationSchema,
  reward: templateAssetValidationSchema,
  achievementLevel: number()
    .required("form.validations.valueMissing")
    .integer("form.validations.badInput")
    .min(1, "form.validations.rangeUnderflow"),
  achievementRuleId: number()
    .required("form.validations.valueMissing")
    .integer("form.validations.badInput")
    .min(1, "form.validations.rangeUnderflow"),
  amount: number()
    .required("form.validations.valueMissing")
    .integer("form.validations.badInput")
    .min(1, "form.validations.rangeUnderflow"),
});
